/**
 * Le décompte dit à VoiceOver chaque étape (l'annonce, 3, 2, 1, « C'est parti ! »), une fois. iOS ne lit
 * pas `accessibilityLiveRegion`, que lisent Android et le web : ailleurs, rien de plus, sans double
 * lecture.
 */
import { useEffect } from "react"
import { AccessibilityInfo, Platform } from "react-native"

export function useAnnounceCountdownStep(label: string | null): void {
    useEffect(() => {
        // `Platform` absent : un rendu sans plateforme (un test qui remplace React Native) n'annonce rien.
        if (label == null || Platform?.OS !== "ios") return
        AccessibilityInfo.announceForAccessibility(label)
    }, [label])
}
